// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"3a757ce5","513":"7f8906e9","703":"ff611b26","787":"1e03b41d"}[chunkId] + ".chunk.js";
};